import { render, staticRenderFns } from "./termsAccepted.vue?vue&type=template&id=dcde6912&scoped=true"
import script from "./termsAccepted.vue?vue&type=script&lang=js"
export * from "./termsAccepted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcde6912",
  null
  
)

export default component.exports